import styled from "styled-components";
import {JackpotBetWidgetHighlightedTextDefaultBox} from "./jackpot-bet-widget-highlighted-text.default.box";

export const JackpotBetWidgetHighlightedText777Box = styled(JackpotBetWidgetHighlightedTextDefaultBox)`
  background: #F5F3D2;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
